<template>
  <div>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#007BFF"
      :is-full-page="true"
    >
    </loading>
    <div class="container-fluid mt-6">
      <div class="card">
        <div class="card-header border-0">
          <div class="row">
            <div class="col-6">
              <h3 class="mb-4 title-2 bold">Listado de Niveles</h3>
            </div>
            <div class="col-6 text-right"><LinkPdf /></div>
          </div>
        </div>
        <LevelFormulaNotice :change-date="formulaChangeDate" />
        <div class="row starter-page">
          <div class="container-fluid">
            <div>
              <vue-content-loading
                v-if="queriedData === null"
                :width="300"
                :height="170"
                primary="#bdc3c7"
                secondary="#95a5a6"
              >
                <svg:rect x="20" y="0" rx="3" ry="3" width="50" height="8" />
                <svg:rect x="80" y="0" rx="3" ry="3" width="50" height="8" />
                <svg:rect x="140" y="0" rx="3" ry="3" width="50" height="8" />
                <svg:rect x="200" y="0" rx="3" ry="3" width="50" height="8" />

                <svg:rect x="20" y="15" rx="3" ry="3" width="50" height="8" />
                <svg:rect x="80" y="15" rx="3" ry="3" width="50" height="8" />
                <svg:rect x="140" y="15" rx="3" ry="3" width="50" height="8" />
                <svg:rect x="200" y="15" rx="3" ry="3" width="50" height="8" />

                <svg:rect x="20" y="30" rx="3" ry="3" width="50" height="8" />
                <svg:rect x="80" y="30" rx="3" ry="3" width="50" height="8" />
                <svg:rect x="140" y="30" rx="3" ry="3" width="50" height="8" />
                <svg:rect x="200" y="30" rx="3" ry="3" width="50" height="8" />

                <svg:rect x="20" y="45" rx="3" ry="3" width="50" height="8" />
                <svg:rect x="80" y="45" rx="3" ry="3" width="50" height="8" />
                <svg:rect x="140" y="45" rx="3" ry="3" width="50" height="8" />
                <svg:rect x="200" y="45" rx="3" ry="3" width="50" height="8" />

                <svg:rect x="20" y="60" rx="3" ry="3" width="50" height="8" />
                <svg:rect x="80" y="60" rx="3" ry="3" width="50" height="8" />
                <svg:rect x="140" y="60" rx="3" ry="3" width="50" height="8" />
                <svg:rect x="200" y="60" rx="3" ry="3" width="50" height="8" />

                <svg:rect x="20" y="75" rx="3" ry="3" width="50" height="8" />
                <svg:rect x="80" y="75" rx="3" ry="3" width="50" height="8" />
                <svg:rect x="140" y="75" rx="3" ry="3" width="50" height="8" />
                <svg:rect x="200" y="75" rx="3" ry="3" width="50" height="8" />

                <svg:rect x="20" y="90" rx="3" ry="3" width="50" height="8" />
                <svg:rect x="80" y="90" rx="3" ry="3" width="50" height="8" />
                <svg:rect x="140" y="90" rx="3" ry="3" width="50" height="8" />
                <svg:rect x="200" y="90" rx="3" ry="3" width="50" height="8" />

                <svg:rect x="20" y="105" rx="3" ry="3" width="50" height="8" />
                <svg:rect x="80" y="105" rx="3" ry="3" width="50" height="8" />
                <svg:rect x="140" y="105" rx="3" ry="3" width="50" height="8" />
                <svg:rect x="200" y="105" rx="3" ry="3" width="50" height="8" />

                <svg:rect x="20" y="120" rx="3" ry="3" width="50" height="8" />
                <svg:rect x="80" y="120" rx="3" ry="3" width="50" height="8" />
                <svg:rect x="140" y="120" rx="3" ry="3" width="50" height="8" />
                <svg:rect x="200" y="120" rx="3" ry="3" width="50" height="8" />

                <svg:rect x="20" y="135" rx="3" ry="3" width="50" height="8" />
                <svg:rect x="80" y="135" rx="3" ry="3" width="50" height="8" />
                <svg:rect x="140" y="135" rx="3" ry="3" width="50" height="8" />
                <svg:rect x="200" y="135" rx="3" ry="3" width="50" height="8" />

                <svg:rect x="20" y="150" rx="3" ry="3" width="110" height="8" />
                <circle cx="206" cy="155" r="5" />
                <circle cx="219" cy="155" r="5" />
                <circle cx="232" cy="155" r="5" />
                <circle cx="245" cy="155" r="5" />
              </vue-content-loading>

              <el-table
                :data="queriedData"
                row-key="id"
                header-row-class-name="thead-desing"
                v-if="queriedData !== null"
                @sort-change="sortChange"
                class="desing"
              >
                <el-table-column
                  label="Periodo"
                  prop="labelDate"
                  min-width="174px"
                >
                  <template v-slot="{ row }">{{ row.labelDate }}</template>
                </el-table-column>

                <el-table-column label="Semana" prop="week" min-width="145px">
                  <template v-slot="{ row }">{{ row.week }}</template>
                </el-table-column>

                <el-table-column label="Score" prop="score" min-width="68px">
                  <template v-slot="{ row }"><ReferentialScore :score="row.score" /></template>
                </el-table-column>

                <el-table-column label="Nivel" prop="level" min-width="90px">
                  <template v-slot:header="{ column }">{{ column.label }}<MetricInfoTooltip :content="levelHelpText" /></template>
                  <template v-slot="{ row }"><LevelBadge :level="row.level" /></template>
                </el-table-column>

                <el-table-column
                  label="Incidencias"
                  prop="incidents"
                  min-width="134px"
                >
                  <template v-slot:header="{ column }">{{ column.label }}<MetricInfoTooltip :content="INCIDENTS_HELP_TEXT" /></template>
                  <template v-slot="{ row }">
                    <strong
                      class="level-number"
                      @click="showModalIncidents(row.start_date, row.end_date)"
                      >{{ row.incidents }}</strong
                    >
                    <small class="level-weight">peso {{ row.weights.incidents }}%</small>
                  </template>
                </el-table-column>
                <el-table-column
                  label="Espera del repartidor / Tardanza"
                  prop="dealerWait"
                  min-width="134px"
                >
                  <template v-slot:header="{ column }">{{ column.label }}<MetricInfoTooltip :content="DEALER_WAIT_HELP_TEXT" /></template>
                  <template v-slot="{ row }">
                    <template v-if="row.formula === 'legacy'">
                      <strong>{{ row.delayRoutes }}</strong>
                      <MetricInfoTooltip :content="latenessHelpText" />
                      <small class="level-weight">Tardanza (cálculo anterior) · peso {{ row.weights.secondary }}%</small>
                    </template>
                    <template v-else>
                      <strong
                        class="level-number"
                        @click="showModalDealerWait(row.start_date, row.end_date)"
                        >{{ row.dealerWait }}</strong
                      >
                      <small class="level-weight">Espera del repartidor · peso {{ row.weights.secondary }}%</small>
                    </template>
                  </template>
                </el-table-column>

                <el-table-column
                  label="Calificaciones"
                  prop="rating"
                  min-width="138px"
                >
                  <template v-slot:header="{ column }">{{ column.label }}<MetricInfoTooltip :content="RATINGS_HELP_TEXT" /></template>
                  <template v-slot="{ row }">
                    <strong
                      class="level-number"
                      @click="
                        showModalQualification(row.start_date, row.end_date)
                      "
                      >{{ row.rating }}</strong
                    >
                    <small class="level-weight">peso {{ row.weights.rating }}%</small>
                  </template>
                </el-table-column>
              </el-table>

              <div
                slot="footer"
                class="mt-4 col-12 d-flex align-items-center justify-content-center justify-content-sm-between flex-wrap"
              >
                <div class="">
                  <p class="card-category">
                    Mostrando {{ from }} a {{ to }} de {{ total }} registros
                  </p>
                </div>
                <div class="pt-3">
                  <base-pagination
                    class="pagination-no-border"
                    @input="next"
                    v-model="pagination.page"
                    :per-page="pagination.rowsPerPage"
                    v-if="pagination.totalItems > 10"
                    :total="total"
                  >
                  </base-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <CustomModal
      :is-modal="modalIncidents"
      @closeModal="closeModalIncidents()"
      :closeOuth="true"
      :width="'xlg'"
    >
      <h5 class="modal-title text semi-bold">Incidencias:</h5>
      <div class="">
        <ContentMetrics
          v-if="getIncidents !== null && getIncidents.hasOwnProperty('extra')"
        >
          <template>
            <Metric
              v-if="getIncidents.extra.hasOwnProperty('totalOrders')"
              :value="getIncidents.extra.totalOrders"
              :title="'Total de Pedidos'"
              :border="true"
            />
            <Metric
              v-if="
                getIncidents.extra.hasOwnProperty('totalOrdersWithoutClaims')
              "
              :value="getIncidents.extra.totalOrdersWithoutClaims"
              :title="'Sin Incidencia'"
              :border="true"
            />
            <Metric
              v-if="getIncidents.extra.hasOwnProperty('totalOrdersWithClaims')"
              :value="getIncidents.extra.totalOrdersWithClaims"
              :title="'Con Incidencia'"
              :border="true"
            />
            <Metric
              v-if="getIncidents.extra.hasOwnProperty('ratio')"
              :value="getIncidents.extra.ratio"
              :title="'Ratio'"
              :border="true"
            />
            <Metric
              v-if="getIncidents.extra.hasOwnProperty('rating')"
              :value="getIncidents.extra.rating"
              :title="'Score'"
            />
          </template>
        </ContentMetrics>
        <StartMetrics
          v-if="
            getIncidents !== null &&
              getIncidents.hasOwnProperty('extra') &&
              getIncidents.extra.hasOwnProperty('claimsGroupByImportance') &&
              getIncidents.extra.hasOwnProperty('totalOrdersWithClaims')
          "
          class="mt-4"
          :data="getIncidents.extra.claimsGroupByImportance"
          :total="getIncidents.extra.totalOrdersWithClaims"
        />
        <div class="mt-4 mb-4 content-table-level">
          <el-table
            :data="getIncidents.items"
            row-key="id"
            header-row-class-name="thead-desing-dark"
            v-if="getIncidents !== null && getIncidents.items.length !== 0"
            class="desing-dark"
          >
            <el-table-column label="Fecha" prop="date" min-width="82px">
              <template v-slot="{ row }">{{ row.date }}</template>
            </el-table-column>

            <el-table-column label="name" prop="client" min-width="100px">
              <template v-slot="{ row }"
                ><strong>{{ row.name }}</strong></template
              >
            </el-table-column>

            <el-table-column label="Nivel" prop="level" min-width="80px">
              <template v-slot="{ row }"
                ><strong
                  class="tag-level-desing"
                  :class="{
                    green:
                      row.level === 'Nivel 1' ||
                      row.level === 'Nivel 2' ||
                      row.level === 'Nivel 3',
                    orange: row.level === 'Nivel 4',
                    red: row.level === 'Nivel 5'
                  }"
                  >{{ row.level }}</strong
                ></template
              >
            </el-table-column>

            <el-table-column
              label="Detalle"
              prop="description"
              min-width="150px"
            >
              <template v-slot="{ row }">
                {{ row.description }}
              </template>
            </el-table-column>
            <el-table-column label="Evidencia" prop="evidence" min-width="90px">
              <template v-slot="{ row }">
                <base-button type="primary" @click="showModal(row.photo_url)">
                  <i class="ni ni-album-2"></i>
                </base-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </CustomModal>
    <CustomModal
      :is-modal="modalDealerWait"
      @closeModal="closeModalDealerWait()"
      :closeOuth="true"
      :width="'xlg'"
    >
      <h5 class="modal-title text semi-bold">Espera del repartidor:</h5>
      <DealerWaitDetails v-if="getDealerWait !== null" :details="getDealerWait" />
    </CustomModal>
    <CustomModal
      :is-modal="modalQualification"
      @closeModal="closeModalQualification()"
      :closeOuth="true"
      :width="'xlg'"
    >
      <h5 class="modal-title text semi-bold">Calificaciones:</h5>
      <div class="">
        <ContentMetrics
          v-if="
            getQualification !== null &&
              getQualification.hasOwnProperty('extra')
          "
        >
          <template>
            <Metric
              v-if="
                getQualification.extra.hasOwnProperty('totalQualifications')
              "
              :value="getQualification.extra.totalQualifications"
              :title="'Calificaciones'"
              :border="true"
            />
            <Metric
              v-if="getQualification.extra.hasOwnProperty('average')"
              :value="getQualification.extra.average"
              :title="'Promedio'"
              :border="true"
            />
            <Metric
              v-if="getQualification.extra.hasOwnProperty('rating')"
              :value="getQualification.extra.rating"
              :title="'Score'"
            />
          </template>
        </ContentMetrics>
        <StartMetrics
          v-if="
            getQualification !== null &&
              getQualification.hasOwnProperty('extra') &&
              getQualification.extra.hasOwnProperty('feedbacksGroupByStars') &&
              getQualification.extra.hasOwnProperty('totalQualifications')
          "
          class="mt-4"
          :data="getQualification.extra.feedbacksGroupByStars"
          :total="getQualification.extra.totalQualifications"
        />
        <div class="mt-4 mb-4 content-table-level">
          <el-table
            :data="getQualification.items"
            row-key="id"
            header-row-class-name="thead-desing-dark"
            v-if="
              getQualification !== null && getQualification.items.length !== 0
            "
            class="desing-dark"
          >
            <el-table-column label="Fecha" prop="date" min-width="50px">
              <template v-slot="{ row }">{{ row.date }}</template>
            </el-table-column>

            <el-table-column label="Cliente" prop="name" min-width="110px">
              <template v-slot="{ row }"
                ><strong>{{ row.name }}</strong></template
              >
            </el-table-column>
            <el-table-column label="Descripción" prop="name" min-width="150px">
              <template v-slot="{ row }"
                ><strong>{{ row.description }}</strong></template
              >
            </el-table-column>
            <el-table-column label="Calificacion" prop="star" min-width="100px">
              <template v-slot="{ row }">
                <span v-for="(item, index) in row.star" :key="index">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6.77923 19.0861C7.1333 19.3573 7.57024 19.2669 8.08252 18.8977L11.9999 16.0199L15.9173 18.8977C16.4296 19.2669 16.8741 19.3573 17.2282 19.0861C17.5747 18.8224 17.65 18.3855 17.4466 17.7903L15.9023 13.1874L19.8574 10.3472C20.3621 9.98563 20.5806 9.58636 20.4374 9.16448C20.2943 8.75014 19.895 8.54674 19.2697 8.55427L14.4182 8.5844L12.9416 3.95884C12.7533 3.35617 12.4444 3.03223 11.9999 3.03223C11.563 3.03223 11.2541 3.35617 11.0582 3.95884L9.58168 8.5844L4.73012 8.55427C4.10484 8.54674 3.7131 8.75014 3.56997 9.16448C3.42683 9.58636 3.63777 9.98563 4.15004 10.3472L8.10512 13.1874L6.55323 17.7903C6.34982 18.3855 6.42516 18.8224 6.77923 19.0861ZM11.9999 14.4605V5.2772C12.0225 5.2772 12.0301 5.28474 12.0451 5.32994L13.2505 9.44322C13.3635 9.81989 13.5669 9.94796 13.9511 9.9329L18.2377 9.83496C18.2829 9.83496 18.2979 9.84249 18.3055 9.85756C18.313 9.88016 18.3055 9.8877 18.2678 9.9103L14.7346 12.3361C14.388 12.5696 14.3428 12.7956 14.4709 13.1648L15.9023 17.2102C15.9173 17.2479 15.9173 17.2554 15.9023 17.2705C15.8872 17.2931 15.8721 17.278 15.842 17.263L12.4444 14.6413C12.2937 14.5208 12.1431 14.4605 11.9999 14.4605Z"
                      fill="#FFBE17"
                    />
                    <path
                      d="M11.9999 14.4605V5.2772C12.0225 5.2772 12.0301 5.28474 12.0451 5.32994L13.2505 9.44322C13.3635 9.81989 13.5669 9.94796 13.9511 9.9329L18.2377 9.83496C18.2829 9.83496 18.2979 9.84249 18.3055 9.85756C18.313 9.88016 18.3055 9.8877 18.2678 9.9103L14.7346 12.3361C14.388 12.5696 14.3428 12.7956 14.4709 13.1648L15.9023 17.2102C15.9173 17.2479 15.9173 17.2554 15.9023 17.2705C15.8872 17.2931 15.8721 17.278 15.842 17.263L12.4444 14.6413C12.2937 14.5208 12.1431 14.4605 11.9999 14.4605Z"
                      fill="#FFBE17"
                    />
                  </svg>
                </span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </CustomModal>
    <CustomModal
      :is-modal="modals"
      @closeModal="modals = false"
      :closeOuth="true"
    >
      <h5 class="modal-title">Adjunto:</h5>
      <div class="card bg-dark text-white border-0 mt-4">
        <img class="card-img" :src="img_url" alt="Adjunto" />
      </div>
      <template slot="footer">
        <base-button type="secondary" @click="modals = false"
          >Close</base-button
        >
      </template>
    </CustomModal>
  </div>
</template>
<script>
import LinkPdf from "@/components/Metrics/LinkPdf";
import LevelFormulaNotice from "@/components/Levels/LevelFormulaNotice";
import { Table, TableColumn } from "element-ui";
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";
import nivelesPaginationMixin from "../../mixin/nivelesPaginationMixin";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { VueContentLoading } from "vue-content-loading";
import CustomModal from "../../components/CustomModal";
import ContentMetrics from "@/components/Levels/ContentMetrics";
import Metric from "@/components/Levels/Metric";
import StartMetrics from "@/components/Levels/StartMetrics";
import DealerWaitDetails from "@/components/Levels/DealerWaitDetails";
import MetricInfoTooltip from "@/components/Levels/MetricInfoTooltip";
import LevelBadge from "@/components/Levels/LevelBadge";
import ReferentialScore from "@/components/Levels/ReferentialScore";
import { INCIDENTS_HELP_TEXT, DEALER_WAIT_HELP_TEXT, RATINGS_HELP_TEXT } from "@/utils/dailyMenuLevelHelpTexts";
import formulaChangeHelpTextsMixin, { readLevelsChangeDate } from "@/mixin/formulaChangeHelpTextsMixin";
export default {
  name: "ListPedidos",
  mixins: [nivelesPaginationMixin, formulaChangeHelpTextsMixin(readLevelsChangeDate)],
  components: {
    VueContentLoading,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    Loading,
    CustomModal,
    ContentMetrics,
    Metric,
    StartMetrics,
    DealerWaitDetails,
    LinkPdf,
    LevelFormulaNotice,
    MetricInfoTooltip,
    LevelBadge,
    ReferentialScore
  },
  data: () => ({
    modals: false,
    img_url: null,
    modalQualification: false,
    modalDealerWait: false,
    modalIncidents: false,
    isLoading: false,
    pageActual: 1,
    INCIDENTS_HELP_TEXT,
    DEALER_WAIT_HELP_TEXT,
    RATINGS_HELP_TEXT
  }),
  computed: {
    ...mapState("niveles", [
      "niveles",
      "formulaChangeDate",
      "pagination",
      "incidents",
      "dealerWait",
      "qualification"
    ]),
    ...mapGetters("niveles", ["getDealerWait", "getIncidents", "getQualification"])
  },
  methods: {
    ...mapActions("niveles", [
      "GET_NIVELES",
      "GET_DEALER_WAIT",
      "GET_INCIDENTS",
      "GET_QUALIFICATION"
    ]),
    ...mapMutations("niveles", [
      "SET_NIVELES",
      "SET_PAGINATION",
      "SET_DEALER_WAIT",
      "SET_INCIDENTS",
      "SET_QUALIFICATION"
    ]),
    showModal(url) {
      this.isLoading = true;
      this.img_url = url;
      this.modals = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 3000);
    },
    closeModalDealerWait() {
      this.SET_DEALER_WAIT(null);
      this.modalDealerWait = false;
    },
    showModalDealerWait(startDate, endDate) {
      this.isLoading = true;
      this.GET_DEALER_WAIT({
        startDate: startDate,
        endDate: endDate
      }).then(() => {
        this.modalDealerWait = true;

        this.isLoading = false;
      });
    },
    closeModalIncidents() {
      this.SET_INCIDENTS(null);
      this.modalIncidents = false;
    },
    showModalIncidents(startDate, endDate) {
      this.isLoading = true;
      this.GET_INCIDENTS({
        startDate: startDate,
        endDate: endDate
      }).then(() => {
        this.modalIncidents = true;

        this.isLoading = false;
      });
    },
    closeModalQualification() {
      this.SET_QUALIFICATION(null);
      this.modalQualification = false;
    },
    showModalQualification(startDate, endDate) {
      this.isLoading = true;
      this.GET_QUALIFICATION({
        start_date: startDate,
        end_date: endDate
      }).then(() => {
        this.isLoading = false;
        this.modalQualification = true;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.level-weight {
  display: block;
  color: #8a8a8a;
  font-size: 11px;
}
::v-deep .el-table th .cell {
  word-break: normal;
}
</style>
